import {Helmet} from "react-helmet";
import {RouteHelper} from "../../../route/RouteHelper";
import {css} from "@emotion/css";
import {
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn,
} from "@moeindal/base-raiko-panel-components";
import React, {useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import TabContext from "@mui/lab/TabContext";
import TabBoxContainer from "../../../component/tabBoxContainer/TabBoxContainer";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import FundAdminDetailBasicInfo from "./FundAdminDetailBasicInfo";
import FundAdminDetailFunds from "./FundAdminDetailFunds";

export default function FundAdminDetail() {

    const {id: adminId = -1} = useParams()
    const {state} = useLocation()

    const [pageTitle, setPageTitle] = useState(state && state.title ? state.title : RouteHelper.FundAdminDetail.name);

    const navigate = useNavigate()

    const [value, setValue] = useState(tabTypes.Info.id);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [selectedFunds, setSelectedFunds] = useState([]);

    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.FundDetail.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoFlexFirstChildGrowOne>
                        <RaikoBreadcrumb
                            breadCrumbItems={[
                                raikoBreadCrumbItemGenerator(
                                    RouteHelper.FundAdminsList.name,
                                    RouteHelper.FundAdminsList.globalUrl),
                                raikoBreadCrumbItemGenerator(
                                    pageTitle,
                                    ""),
                            ]}/>
                        <RaikoButtonSecondary
                            label={"بازگشت"}
                            onClick={_ => {
                                navigate(-1)
                            }}/>
                    </RaikoFlexFirstChildGrowOne>

                    <TabContext value={value}>
                        <TabBoxContainer>
                            <TabList onChange={handleChange} id="default-tab-container" variant="scrollable">
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Info.title}
                                     value={tabTypes.Info.id}
                                />
                                <Tab icon={<div id="tabIcon"/>} iconPosition="start"
                                     label={tabTypes.Funds.title}
                                     value={tabTypes.Funds.id}
                                />
                            </TabList>
                        </TabBoxContainer>

                        <TabPanel value={tabTypes.Info.id}>
                            <FundAdminDetailBasicInfo selectedFunds={setSelectedFunds}/>
                        </TabPanel>

                        <TabPanel value={tabTypes.Funds.id}>
                            <FundAdminDetailFunds selectedFunds={selectedFunds} setSelectedFunds={setSelectedFunds} />
                        </TabPanel>
                    </TabContext>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}


const tabTypes = {
    Info: {
        id: "info",
        title: "اطلاعات پایه"
    }, Funds: {
        id: "funds",
        title: "صندوق"
    },
}
